/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Gespraechsfuehrungchancenwerkids4Inputs */

const de__field_gespraechsfuehrungchancenwerkids4 = /** @type {(inputs: _Field_Gespraechsfuehrungchancenwerkids4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprächsführung Chancen WerkIDs`)
};

/**

* @param {_Field_Gespraechsfuehrungchancenwerkids4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_gespraechsfuehrungchancenwerkids4 = /** @type {((inputs?: _Field_Gespraechsfuehrungchancenwerkids4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Gespraechsfuehrungchancenwerkids4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_gespraechsfuehrungchancenwerkids4(inputs)
});
export { _field_gespraechsfuehrungchancenwerkids4 as "_field_gespraechsfuehrungChancenWerkIDs" }